export default {
    common: {
        home: '首页',
        category: '分类',
        product: '商品',
        search: '搜索',
        about: '关于',
        loading: '加载中...',
        error: '出错了',
        noData: '暂无数据',
        contact: '联系我们',
        buy: '购买',
        price: '价格',
        originalPrice: '原价',
        hot: '热门',
        new: '新品',
        tags: '标签',
        exploreMore: '探索更多',
        viewAll: '查看全部',
        startShopping: '开始购物',
        quickLinks: '快速链接',
        allRightsReserved: '版权所有',
        close: '关闭',
        qr: '二维码',
        phone: '电话',
        products: '件商品',
        share: '分享',
        linkCopied: '链接已复制',
        backHome: '返回首页',
        allCategories: '全部分类',
        sortBy: '排序方式',
        totalProducts: '共 {count} 件商品',
        timeRange: '时间范围',
        allProducts: '全部商品'
    },
    nav: {
        home: '首页',
        categories: '商品分类',
        hot: '热门商品',
        new: '新品上架',
        about: '关于我们'
    },
    shop: {
        name: '拾光',
        slogan: '余下的小破店',
        description: '我们提供各种的软件工具、系统代码、平台会员等虚拟物品和实体物品'
    },
    category: {
        searchPlaceholder: '搜索分类...',
        software: '软件工具',
        code: '系统代码',
        member: '平台会员',
        book: '电子书籍',
        custom: '定制软件',
        other: '其他商品',
        description: '探索我们精选的数字产品'
    },
    notice: {
        title: '公告通知',
        welcome: '欢迎来到我们的店铺',
        contact: '联系方式说明'
    },
    contact: {
        title: '联系方式',
        qq: 'QQ',
        wechat: '微信',
        email: '邮箱',
        phone: '电话',
        copy: '复制',
        copied: '已复制到剪贴板',
        copyFailed: '复制失败',
        buyTip: '如需购买此商品，请通过以下方式联系我们：',
        startChat: '开始聊天',
        wechatTip: '请添加微信好友进行联系'
    },
    theme: {
        title: '主题设置',
        light: '亮色主题',
        dark: '暗色主题',
        techBlue: '蓝色科技'
    },
    language: {
        title: '语言设置',
        chinese: '中文',
        english: 'English'
    },
    sort: {
        default: '默认排序',
        priceAsc: '价格从低到高',
        priceDesc: '价格从高到低',
        nameAsc: '名称A-Z',
        nameDesc: '名称Z-A',
        newest: '最新发布',
        popularity: '最受欢迎'
    },
    filter: {
        byTag: '按标签筛选'
    },
    product: {
        description: '商品描述',
        related: '相关商品',
        notFound: '商品不存在',
        notFoundDesc: '您查找的商品可能已下架或不存在',
        features: '功能特性',
        specifications: '技术规格',
        demo: '在线演示',
        demoImages: '产品演示图片',
        demoGallery: '产品演示画廊',
        detailImages: '商品详细图片',
        viewDemo: '查看演示',
        demoNotAvailable: '演示暂不可用',
        noDetailImages: '暂无详细图片',
        installGuide: '安装说明',
        framework: '开发框架',
        database: '数据库',
        javaVersion: 'Java版本',
        frontend: '前端技术',
        cache: '缓存',
        security: '安全',
        uiLibrary: 'UI库',
        buildTool: '构建工具',
        typescript: 'TypeScript',
        supportedLanguages: '支持语言',
        platforms: '支持平台',
        memoryRequired: '内存要求',
        diskSpace: '磁盘空间',
        jdkSupport: 'JDK支持',
        inStock: '有库存',
        lowStock: '库存不足',
        outOfStock: '缺货',
        month: '月'
    },
    search: {
        enterKeyword: '请输入搜索关键词',
        placeholder: '搜索商品名称、标签或描述...',
        found: '找到',
        noResults: '没有找到相关商品',
        clearSearch: '清空搜索',
        hotTags: '热门标签',
        categories: '商品分类'
    },
    gallery: {
        gridView: '网格视图',
        masonryView: '瀑布流视图',
        slideshow: '幻灯片模式',
        clickToPreview: '点击预览',
        featured: '精选',
        noImages: '暂无演示图片',
        imagePreview: '图片预览',
        previous: '上一张',
        next: '下一张',
        download: '下载',
        downloadSuccess: '下载成功',
        downloadFailed: '下载失败',
        resolution: '分辨率',
        category: '分类',
        screenshot: '截图',
        interface: '界面',
        management: '管理',
        component: '组件',
        visualization: '可视化',
        responsive: '响应式',
        pause: '暂停',
        play: '播放',
        defaultTitle: '演示图片 {number}',
        defaultDescription: '产品功能演示图片',
        dashboardTitle: '系统仪表板',
        dashboardDesc: '展示系统的主要仪表板界面',
        loginTitle: '登录界面',
        loginDesc: '用户登录页面展示',
        userTitle: '用户管理',
        userDesc: '用户管理模块界面',
        tableTitle: '数据表格',
        tableDesc: '数据表格组件展示',
        formTitle: '表单界面',
        formDesc: '表单组件功能展示',
        chartTitle: '图表展示',
        chartDesc: '数据可视化图表',
        feature: '功能展示',
        demo: '演示操作',
        mobileTitle: '移动端适配',
        mobileDesc: '响应式设计，完美适配移动设备'
    },
    about: {
        title: '关于我们',
        subtitle: '余下的小破店，一个由野生程序员搭建的商品服务平台',
        ourStory: '我们的故事',
        storyText1: '我们是一家专注于产品销售的专业平台，致力于为用户提供高质量的服务。',
        storyText2: '自成立以来，我们始终秉承"质量第一、服务至上"的经营理念，确保为用户提供正版、可靠的产品。',
        storyText3: '我们的团队由经验丰富的技术专家和客服人员组成，能够为您提供专业的产品咨询和售后服务，让您的购买体验更加愉快。',
        productsCount: '优质商品',
        categoriesCount: '商品分类',
        satisfaction: '客户满意度',
        support: '在线支持',
        ourServices: '我们的服务',
        service1Title: '正版保证',
        service1Desc: '所有商品均为正版授权，确保您的使用安全和合法性',
        service2Title: '安全可靠',
        service2Desc: '采用先进的安全技术，保护您的个人信息和交易安全',
        service3Title: '专业服务',
        service3Desc: '专业的客服团队为您提供7×24小时的咨询和技术支持',
        service4Title: '品质保障',
        service4Desc: '严格的质量控制流程，确保每一款产品都符合高品质标准',
        ourAdvantages: '我们的优势',
        advantage1Title: '精选商品',
        advantage1Desc: '我们精心挑选每一款商品，确保为您提供最优质的数字产品',
        advantage2Title: '快速交付',
        advantage2Desc: '完善的订单处理系统，确保您能够快速获得购买的商品',
        advantage3Title: '合理价格',
        advantage3Desc: '直接与厂商合作，去除中间环节，为您提供最具竞争力的价格',
        contactUs: '联系我们',
        contactDesc: '如果您有任何问题或需要帮助，请随时联系我们的客服团队',
        feature1: '100%正版保证',
        feature2: '专业技术支持',
        feature3: '快速响应服务',
        feature4: '优质用户体验'
    },
    categories: {
        description: '浏览我们精心分类的商品，快速找到您需要的产品',
        empty: '暂无商品分类',
        noProducts: '该分类暂无商品'
    },
    hot: {
        description: '发现最受欢迎的商品，这些都是用户喜爱的热门选择',
        empty: '暂无热门商品'
    },
    new: {
        description: '查看我们最新上架的商品，抢先体验最新产品',
        empty: '暂无新品'
    },
    time: {
        all: '全部时间',
        lastWeek: '最近一周',
        lastMonth: '最近一个月',
        last3Months: '最近三个月'
    },
    view: {
        grid: '网格视图',
        list: '列表视图',
        mode: '视图模式',
        compact: '紧凑',
        detailed: '详细',
        compactTip: '节省空间',
        detailedTip: '悬停展开'
    },
    categoryNav: {
        all: '全部',
        searchCategory: '搜索分类',
        searchPlaceholder: '搜索分类...',
        expandAll: '展开所有分类',
        collapseAll: '收起所有分类',
        resetView: '重置视图',
        foundCategories: '找到 {count} 个分类'
    }
}
